import { Button, IconButton, Tooltip } from '@mui/material'
import logo from '../../images/logoDHSG.png'
import LoginRoundedIcon from '@mui/icons-material/LoginRounded';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux';
import { ProfileStudent, StudentType } from '../../Utils/DataType';
import AxiosAuth from '../../api/AxiosAuth';
import AxiosClient from '../../api/AxiosClient';
import AccountOption from '../../components/AccountMenu';
import LogoutIcon from '@mui/icons-material/Logout';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import MenuDrawer from '../../components/Drawer';
import { useState } from 'react';
export default function Header() {
    let auth = useSelector<RootState, boolean>(state => state.auth);
    const [openDrawer, setOpenDrawer] = useState<boolean>(false);
    function handleLogout(): void {
        window.location.reload();
        localStorage.removeItem('sgu_student_token');
        // AxiosAuth.post('logout').then((data) => {
        //     console.log(data);
        // })
    }

    return (
        <>
            <header className="page-header">
                <div className="page-header--left w-3/4">
                    <div className="logo">
                        <img src={logo} alt="Logo Đại học Sài Gòn" className='w-full height-full object-contain' />
                    </div>
                    <div className="page-header--menu">
                        <li><NavLink to={'/'} className={({ isActive }) => isActive ? 'menu-item menu-active' : 'menu-item'}>Trang chủ</NavLink></li>
                        <li><NavLink to={'notification'} className={({ isActive }) => isActive ? 'menu-item menu-active' : 'menu-item'}>Thông báo</NavLink></li>
                        <li><NavLink to={'schedule'} className={({ isActive }) => isActive ? 'menu-item menu-active' : 'menu-item'}>Xem thời khóa biểu</NavLink></li>
                        {/* <li><NavLink to={'exam'} className={({ isActive }) => isActive ? 'menu-item menu-active' : 'menu-item'}>Xem lịch thi</NavLink></li> */}
                        <li><NavLink to={'contact'} className={({ isActive }) => isActive ? 'menu-item menu-active' : 'menu-item'}>Liên hệ</NavLink></li>
                    </div>
                </div>
                <div className="page-header--right flex justify-end items-center w-1/4">
                    {!auth && <a href="/login">
                        <Button variant='contained' startIcon={<LoginRoundedIcon />}> Đăng nhập</Button>
                    </a>}
                    {auth && (
                        <div className='flex items-center gap-4' >
                            <AccountOption />
                            <div>
                                <Tooltip title='Đăng xuất' children={<IconButton size='large' color='primary' onClick={handleLogout}>< LogoutIcon fontSize={'medium'} /></IconButton>} />
                            </div>

                        </div>)}
                </div>
            </header>
            <div className='page-header--md'>
                <div className='grid grid-cols-3 w-full'>
                    <div className='flex justify-start items-center'>
                        <IconButton onClick={() => setOpenDrawer(true)}>
                            <MenuRoundedIcon />
                        </IconButton>
                    </div>
                    <div className='flex justify-center items-center'>
                        <div className="logo">
                            <img src={logo} alt="Logo Đại học Sài Gòn" className='w-full height-full object-contain' />
                        </div>
                    </div>
                    <div className='flex justify-end items-center'>
                        {!auth && <a href="/login">
                            <Button variant='contained' startIcon={<LoginRoundedIcon />}
                                sx={{ fontSize: '0.5rem', width: '1rem' }}
                                size='small'

                            > </Button>
                        </a>}
                    </div>
                </div>
            </div>
            <MenuDrawer open={openDrawer} setOpen={setOpenDrawer} />
        </>
    )
}   